import { getToken } from "./token-interceptor";
import { handleErrorIfAvailable } from "../error-handler/index";
import { structureQueryParams } from "../helper-methods";


export const getRequestLog = (url) =>
{
  const camelCased = url
    .split("/")
    .filter(Boolean)
    .map((part, idx) =>
      idx === 0
        ? part.toLowerCase()
        : part.charAt(0).toUpperCase() + part.slice(1)
    )
    .join("");

  return camelCased;
}

export const makeGetRequest = async (
  url,
  attachToken = false,
  params = null
) => {
  let base = `et${getRequestLog(new URL(url, window.location.origin).pathname)}`;
  let allSymbols = `Use the tanstack query with the symbols:
  @g${base}Options
  @G${base}Data
  @G${base}Response
  `
  
  console.log(`Add this to lovable for the page ${window.location.pathname} : ${new URL(url, window.location.origin).pathname} and symbols from the folder src/services/openapi-ts-client.express-oas-generator3-0730/ the files, types.gen.ts, schemas.gen.ts, and @tanstack/react-query.gen.ts:\n${allSymbols}`)
  let queryString = "";
  if (params) {
    queryString = structureQueryParams(params);
  }
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (attachToken) {
    try {
      const authToken = await getToken();
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
    } catch (e) {
      console.log(e);
    }
  }
  // debugger;
  try {
    const response = await fetch(url + queryString, {
      method: "GET",
      headers: headers,
    });
    const isErrorAvailable = await handleErrorIfAvailable(response);
    if (!isErrorAvailable) {
      const jsonResponse = await response.json();
      if (jsonResponse.error === false) {
        return jsonResponse;
      } else {
        console.log(jsonResponse);
        throw jsonResponse;
      }
    } else {
      return;
    }
  } catch (error) {
    console.log("XHR GET Error: ", error);
    throw error;
  }
};

export const makePostRequest = async (
  url,
  attachToken = false,
  params = {}
) => {
  let base = `ost${getRequestLog(new URL(url, window.location.origin).pathname)}`;
  let allSymbols = `Use the tanstack query with the symbols:
  @p${base}Options
  @P${base}Data
  @P${base}Response
  @P${base}Mutation
  `
  console.log(`Add this to lovable for the page ${window.location.pathname} : ${new URL(url, window.location.origin).pathname} and symbols from the folder src/services/openapi-ts-client.express-oas-generator3-0730/ the files, types.gen.ts, schemas.gen.ts, and @tanstack/react-query.gen.ts:\n${allSymbols}\nSome route parameters might be polution the symbol lookup`)
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (attachToken) {
    try {
      const authToken = await getToken();
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
    } catch (e) {
      console.log("Error fetching auth token: ", e);
    }
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(params),
    });
    const isErrorAvailable = await handleErrorIfAvailable(response);
    if (!isErrorAvailable) {
      const jsonResponse = await response.json();
      if (jsonResponse.error === false) {
        return jsonResponse;
      } else {
        console.log(jsonResponse);
        throw jsonResponse;
      }
    } else {
      return;
    }
  } catch (error) {
    console.log("XHR POST Error: ", error);
    throw error;
  }
};

export const makePutRequest = async (url, attachToken = false, params = {}) => {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  let base = `ut${getRequestLog(new URL(url, window.location.origin).pathname)}`;
  let allSymbols = `Use the tanstack query with the symbols:
  @p${base}Options
  @P${base}Data
  @P${base}Response
  @P${base}Mutation
  `
  console.log(`Add this to lovable for the page ${window.location.pathname} : ${new URL(url, window.location.origin).pathname} and symbols from the folder src/services/openapi-ts-client.express-oas-generator3-0730/ the files, types.gen.ts, schemas.gen.ts, and @tanstack/react-query.gen.ts:\n${allSymbols}\nSome route parameters might be polution the symbol lookup`)
  if (attachToken) {
    try {
      const authToken = await getToken();
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
    } catch (e) {
      console.log("Error fetching auth token: ", e);
    }
  }
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(params),
      })
        .then((res) => {
          handleErrorIfAvailable(res);
          return res.json();
        })
        .then(
          (jsonResponse) => {
            if (jsonResponse.error === false) {
              resolve(jsonResponse);
            } else {
              console.log(jsonResponse);
              reject(jsonResponse);
            }
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    } catch (e) {
      console.log("handleErrorIfAvailable >>", e);

      reject();
    }
  });
};

export const makeDeleteRequest = async (
  url,
  attachToken = false,
  params = {}
) => {
  let base = `elete${getRequestLog(new URL(url, window.location.origin).pathname)}`;
  let allSymbols = `Use the tanstack query with the symbols:
  @d${base}Options
  @D${base}Data
  @D${base}Response
  @D${base}Mutation
  `
  console.log(`Add this to lovable for the page ${window.location.pathname} : ${new URL(url, window.location.origin).pathname} and symbols from the folder src/services/openapi-ts-client.express-oas-generator3-0730/ the files, types.gen.ts, schemas.gen.ts, and @tanstack/react-query.gen.ts:\n${allSymbols}\nSome route parameters might be polution the symbol lookup`)
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  if (attachToken) {
    try {
      const authToken = await getToken();
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
    } catch (e) {
      console.log("Error fetching auth token: ", e);
    }
  }
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(params),
      })
        .then((res) => {
          handleErrorIfAvailable(res);
          return res.json();
        })
        .then(
          (jsonResponse) => {
            if (jsonResponse.error === false) {
              resolve(jsonResponse);
            } else {
              console.log(jsonResponse);
              reject(jsonResponse);
            }
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    } catch (e) {
      console.log("handleErrorIfAvailable >>", e);

      reject();
    }
  });
};

// export const uploadFileMultiPart = async (
//   attachToken = false,
//   formData,
//   mediaType = "image"
// ) => {
//   let headers = {};

//   if (attachToken) {
//     try {
//       const authToken = await getToken();
//       if (authToken) {
//         headers["Authorization"] = "Bearer " + authToken;
//       }
//     } catch (e) {
//       console.log("Error fetching auth token: ", e);
//     }
//   }

//   return new Promise((resolve, reject) => {
//     try {
//       fetch(cloudinaryURL, {
//         method: "POST",
//         headers: headers,
//         body: formData,
//       })
//         .then((res) => {
//           handleErrorIfAvailable(res);
//           return res.json();
//         })
//         .then(
//           (jsonResponse) => {
//             resolve(jsonResponse);
//           },
//           (error) => {
//             reject(error);
//           }
//         )
//         .catch((error) => {
//           reject(error);
//         });
//     } catch (e) {
//       console.log(e);
//       reject();
//     }
//   });
// };

export const uploadFile = async (url, attachToken = false, formData) => {
  let base = `ost${getRequestLog(new URL(url, window.location.origin).pathname)}`;
  let allSymbols = `Use the tanstack query with the symbols:
  @p${base}Options
  @P${base}Data
  @P${base}Response
  @P${base}Mutation
  `
  console.log(`Add this to lovable for the page ${window.location.pathname} : ${new URL(url, window.location.origin).pathname} and symbols from the folder src/services/openapi-ts-client.express-oas-generator3-0730/ the files, types.gen.ts, schemas.gen.ts, and @tanstack/react-query.gen.ts:\n${allSymbols}\nSome route parameters might be polution the symbol lookup`)
  let headers = {};
  if (attachToken) {
    try {
      const authToken = await getToken();
      if (authToken) {
        headers["Authorization"] = "Bearer " + authToken;
      }
    } catch (e) {
      console.log("Error fetching auth token: ", e);
    }
  }
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: "POST",
        headers: headers,
        body: formData,
      })
        .then(
          (res) => {
            handleErrorIfAvailable(res);
            return res.json();
          },
          (error) => {
            reject(error);
          }
        )
        .then(
          (jsonResponse) => {
            resolve(jsonResponse);
          },
          (error) => {
            reject(error);
          }
        )
        .catch((error) => {
          reject(error);
        });
    } catch (e) {
      console.log(e);
      reject();
    }
  });
};
